import { render, staticRenderFns } from "./AddCustomerTag.vue?vue&type=template&id=0553822b&scoped=true"
import script from "./AddCustomerTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddCustomerTag.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AddCustomerTag.vue?vue&type=style&index=0&id=0553822b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553822b",
  null
  
)

export default component.exports